export const formatedAmount = (amount) => {
  const amountdata = amount
    ? (+parseFloat(amount).toFixed(2)).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : 0;
  return amountdata;
};

export const currencies = [
  "USD", "EUR", "GBP", "JPY", "AUD", "CAD", "CHF", "SEK", "NOK", "DKK",
  "PLN", "CZK", "HUF", "BGN", "RON", "TRY", "ZAR", "HKD", "SGD", "CNY",
  "KRW", "MXN", "BRL", "INR", "IDR", "MYR", "PHP", "THB", "ISK",
];
